// extracted by mini-css-extract-plugin
export var blocks = "program-module--blocks--e8797";
export var blue = "program-module--blue--c3820";
export var desc = "program-module--desc--ee5c3";
export var itemList = "program-module--item-list--47069";
export var orange = "program-module--orange--c134d";
export var program = "program-module--program--56042";
export var purple = "program-module--purple--1e316";
export var yellow = "program-module--yellow--dd824";